/* ---------------------- */
/*         SEARCH         */
/* ---------------------- */

clearSearchInput = {
    init: function () {
        $(".search__input .clear").on('click', function () {
            $(".search__input input.search").val('')
            $(".search__input input.search").focus()
        });
    }
}

hideErrorOnFirstLoad = {
    init: function () {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('q')) {
            $(".search__results").css('opacity', 1)
        }
    }
}

$(function () {
    //clearSearchInput.init();
    hideErrorOnFirstLoad.init();
});